import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Box from "@material-ui/core/Box";

import EllipsedTextNew from "../Common/EllipsedTextNew";

import {
  LOGS_TAB,
  STATIC_TAB,
  DYNAMIC_TAB,
} from "../../constants/siteEntranceExit";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  tab: {
    minWidth: "120px",
    textAlign: "center",
    backgroundColor: colors.white,
    borderRadius: "2px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderBottom: "none",
    marginRight: "10px",
    padding: "6px",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  inactive: {
    color: colors.black54,
    height: "32px",
    cursor: "pointer",
  },
  active: {
    color: colors.black87,
    height: "34px",
    cursor: "default",
    paddingTop: "4px",
    borderTopWidth: "3px",
  },
};

const Tab = (props) => {
  const { classes, type, tab } = props;

  let color, title;
  if (type === LOGS_TAB) {
    color = colors.yellowTab;
    title = I18n.get("site_log");
  } else if (type === STATIC_TAB) {
    color = colors.primary;
    title = tab.title;
  } else if (type === DYNAMIC_TAB) {
    color = colors.graphPurple;
    //title = `#${tab.eventGroupId} ${I18n.get("site_" + tab.status)}`;
    title = `#${tab.eventGroupId} ${
      get(tab, ["zone", "name"]) || I18n.get("site_" + tab.status)
    }`;
  }

  return (
    <Box
      onClick={props.onClick}
      className={`${props.active ? classes.active : classes.inactive} ${
        classes.tab
      }`}
      style={{
        borderColor: color,
        paddingRight: type === DYNAMIC_TAB ? "0px" : "6px",
        maxWidth: "179px",
      }}
    >
      <EllipsedTextNew text={title} maxWidth={150} />
      {type === DYNAMIC_TAB && (
        <Box component="span">
          <img
            src={images.closeIcon}
            alt="close"
            style={{
              margin: "5px 6px 6px 5px",
              float: "right",
              opacity: props.active ? "0.87" : "0.54",
              width: "10px",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              props.closeTab();
            }}
          />
        </Box>
      )}
    </Box>
  );
};

Tab.propTypes = {
  active: PropTypes.bool,
  type: PropTypes.oneOf([LOGS_TAB, STATIC_TAB, DYNAMIC_TAB]).isRequired,
  closeTab: PropTypes.func,
};

export default withStyles(styles)(Tab);
